
export class MobileNavigation {
    constructor() {
        this.#navigationOpenerCloser();
    }

    #navigationOpenerCloser() {
        const mobileNavigationBlock = document.querySelector('.mobile-navigation');
        const mobileNavigationContainer = document.querySelector('#mobile-navigation-container');
        if (mobileNavigationContainer) {
            mobileNavigationContainer.style.display = 'none';
        }

        if (mobileNavigationBlock && mobileNavigationContainer) {
            const navigationCloseElement = mobileNavigationContainer.querySelector('.mobile-navigation-close');
            const navigationOpenElement = mobileNavigationBlock.querySelector('.mobile-navigation-toggle');

            mobileNavigationContainer.classList.remove('active');

            if (navigationCloseElement) {
                navigationCloseElement.addEventListener('click', () => {
                    mobileNavigationContainer.classList.remove('active');
                    setTimeout(() => {
                        mobileNavigationContainer.style.display = 'none'
                    }, 150)
                });
            }

            if (navigationOpenElement) {
                navigationOpenElement.addEventListener('click', () => {
                    mobileNavigationContainer.style.display = ''
                    setTimeout(() => {
                        mobileNavigationContainer.classList.add('active');
                    }, 100)
                });
            }
        }
    }
}
